import { rem } from 'polished'

export const LABEL_HEIGHT = rem(24)
